import { QuoteResquestLineWithBatchInfo } from "#modules/quoteRequestLines/QuoteRequestLines.page";
import { QuoteRequestLinesListItem } from "#types/QuoteRequestLinesListItem";

export const makeQuoteRequestLinesListData = (
  quoteRequestLines: QuoteResquestLineWithBatchInfo[],
) => {
  const quoteRequestLinesListData: QuoteRequestLinesListItem[] = [];

  quoteRequestLines.forEach((qrl) => {
    const data: QuoteRequestLinesListItem = {
      id: qrl.id,
      price: 0,
      quantity: qrl.quantity,
      createdAt: qrl.createdAt,
      materialGrade: qrl.materialGrade,
      part: {
        ...qrl.part,
        thumbnail: qrl.part.urlPng3D ?? qrl.part.urlPng2D ?? "/images/no-preview.png",
        files: qrl.part.files,
      },
      quoteRequest: {
        id: qrl.quoteRequest.id,
        reference: qrl.quoteRequest.reference,
        isArchived: qrl.quoteRequest.isArchived,
        client: qrl.quoteRequest.client?.name ?? "",
      },
      layout: qrl.layout,
      processSteps: qrl.processSteps,
      isBatch: qrl.isBatch,
    };
    quoteRequestLinesListData.push(data);
  });

  return quoteRequestLinesListData;
};
